import { render, staticRenderFns } from "./PrinterLights.vue?vue&type=template&id=4f2abbaf&"
import script from "./PrinterLights.vue?vue&type=script&lang=js&"
export * from "./PrinterLights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports